import React, { useState } from 'react';
import { Segment, Header, Grid, Accordion, Icon } from 'semantic-ui-react';
import { ErrorMessage, Field as Fieldmik } from 'formik';
import PackagingTypeDropdown from '../../dynamicComponent/packagingTypeDropdown';
import { MyInput } from '../../formikInput/input';
import { MyNumInput } from '../../dynamicComponent/myInputs';


const SingleProduct = ({ deliveryIndex, products, orderDetail, orderEditMode, t, serviceType}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const customerNo = localStorage.getItem('customerNumber');

    const handleClick = ( e, titleProps) => {
        const { index } = titleProps;

        const newIndex = activeIndex === index ? -1 : index
        setActiveIndex(newIndex)
    }

    return (
        <Accordion fluid styled>
            {products && products.map(( product, productIndex) => {
                return(
                    <React.Fragment>
                        <Accordion.Title 
                            active={activeIndex === productIndex}
                            index={productIndex}
                            onClick={handleClick}
                        >
                            <Icon name ='dropdown' />
                            {`Product ${productIndex + 1}`}
                        </Accordion.Title>
                        <Accordion.Content active={activeIndex === productIndex}>                        
                            <div className="pad w3-white small">
                                <Grid columns={4}>
                                    { customerNo != 1122 ?  
                                        <React.Fragment>                            
                                            <Grid.Column width="3">
                                                <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">
                                                    {t("packaging_type") || "Packaging Type Name"}
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column width="4">
                                                <Fieldmik 
                                                    name={`deliveries[${deliveryIndex}].products[${productIndex}].packaging_type_id`} 
                                                    component={PackagingTypeDropdown}
                                                    placeholder="Packaging Type"  
                                                    disabled={orderEditMode ? false : true}
                                                    value={product.packaging_type_id} 
                                                />
                                                <ErrorMessage name={`deliveries[${deliveryIndex}].products[${productIndex}].packaging_type_name`}>
                                                    {(error) => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                </ErrorMessage>
                                            </Grid.Column>
                                            
                                            <Grid.Column width="3">
                                                <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">    
                                                    {t("product_category") || "Product Category Name"}
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column width="4">
                                                <Header className="p-bold-600 labelName" size="tiny" as="label"color="black">
                                                    {product.product_category_name || "NA"}
                                                </Header>
                                            </Grid.Column>
                                            
                                        </React.Fragment>
                                        : 
                                        ""
                                    }
                                    
                                
                                    {customerNo != 1122 ?
                                        <React.Fragment>
                                            <Grid.Column width="3">
                                                <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">
                                                    {t("invoice_code") || "Invoice No"}
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column width="4">
                                                <Header className="p-bold-600 labelName" size="tiny" as="label"color="black">
                                                    {product.invoice_no || "NA"}
                                                </Header>
                                            </Grid.Column>
                                        </React.Fragment>
                                        :
                                        ""
                                    }

                                    <Grid.Column width="3">
                                        <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">
                                            {t("quantity") || "Quantity"}
                                        </Header>
                                    </Grid.Column>
                                    <Grid.Column width="4">           
                                        <Fieldmik 
                                            disabled={orderEditMode ? false : true}
                                            component={MyInput} 
                                            name={`deliveries[${deliveryIndex}].products[${productIndex}].quantity`} 
                                            placeholder="Quantity"  
                                            value={product.quantity} 
                                        />
                                    </Grid.Column>      
                                    
                                    <Grid.Column width="3">
                                        <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">
                                            {t("product_code") || "Product Code"}
                                        </Header>
                                    </Grid.Column>
                                    <Grid.Column width="4">
                                        <Header className="p-bold-600 labelName" size="tiny" as="label"color="black">
                                            {product.sku?.product_code || "NA"}
                                        </Header>
                                    </Grid.Column>
                                
                                    <Grid.Column width="3">
                                        <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">
                                            {t("product_name") || "Product Name"}
                                        </Header>
                                    </Grid.Column>
                                    <Grid.Column width="4">
                                        <Header className="p-bold-600 labelName" size="tiny" as="label"color="black">
                                            <div style={{ flexWrap: "wrap" ,wordWrap: 'break-word'}}>
                                                <p>{product.sku?.product_name || "NA"}</p>
                                            </div>
                                        </Header>
                                    </Grid.Column>   
                                    

                                    { serviceType && serviceType.service_type_id === 2 ? 
                                        <React.Fragment>
                                            <Grid.Column width="3">
                                                <Header className="p-bold-600 labelName" size="tiny" as="label"color="grey">    
                                                    {t("lbh") || "Length*Breadth*Height"}
                                                </Header>
                                            </Grid.Column>
                                            <Grid.Column>
                                                {/* <Header className="p-bold-600 labelName" size="tiny" as="label"color="black">        
                                                    {(product.length || product.breadth || product.height) ? `${product.length}in x `+`${product.breadth}in x `+`${product.height}in` : "NA"}
                                                </Header> */}        
                                                <Fieldmik 
                                                    disabled={orderEditMode ? false : true}
                                                    component={MyNumInput} 
                                                    name={`deliveries[${deliveryIndex}].products[${productIndex}].length`} 
                                                    placeholder="inches"  
                                                    value={product.length} 
                                                />
                                            </Grid.Column>
                                            <Grid.Column >
                                                <Fieldmik 
                                                    disabled={orderEditMode ? false : true}
                                                    component={MyNumInput} 
                                                    name={`deliveries[${deliveryIndex}].products[${productIndex}].breadth`} 
                                                    placeholder="inches"  
                                                    value={product.breadth} 
                                                />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Fieldmik 
                                                    disabled={orderEditMode ? false : true}
                                                    component={MyNumInput} 
                                                    name={`deliveries[${deliveryIndex}].products[${productIndex}].height`} 
                                                    placeholder="inches"  
                                                    value={product.height} 
                                                />
                                            </Grid.Column>
                                        </React.Fragment>
                                        : 
                                        ""
                                    }
                                    
                                </Grid>
                            </div>
                           
                        </Accordion.Content>
                    </React.Fragment>
                )
            })}
        </Accordion>
    )
}

export default SingleProduct;